<template>
    <div class="container">


       <div class="panel">
			<h2>开放平台店铺 <span class="btn btn-add" @click="addShop">添加店铺</span></h2>
			<div class="table">
				<div class="header">
					<div class="name">平台名称</div>
					<div class="name">店铺名称</div>
					<div class="openid">用户openId</div>
					<div class="auth">授权状态</div>

					<div class="action">操作</div>
				</div>
				<div v-for="(item,index) in list" :key="index" class="item">
					<div class="name">{{ item.open_name }}</div>
					<div class="name">{{ item.shop_name }}</div>
					<div class="openid">{{ item.open_id }}</div>
					<div class="auth">{{ item.is_auth? (item.is_expires?'授权过期':'已授权'):'未授权' }}</div>
					<div class="action">
						<span class="btn-default" @click="auth(item.id)" v-if="!item.is_auth">店铺授权</span>
						<span class="btn-default" @click="auth(item.id)" v-if="item.is_auth && item.is_expires">重新授权</span>
					</div>
				</div>
			</div>
		</div>
        <popup :show.sync="is_popup_show" width="300px" height="250px" @on-close="close">
			<h2>添加店铺</h2>
			<div class="form">

				<div class="form-group w50">
                    <div class="form-label">平台：</div>
                    <div class="form-control">
                        <select v-model="open_type">
                        <option value="0">请选择</option>
                        <option
                            v-for="(v, k) in shop_list"
                            :key="`dpc1` + k"
                            :value="v.type"
                        >
                            {{ v.name }}
                        </option>
                        </select>
                    </div>
                </div>
				<div class="btn-submit" @click="submit">确认</div>
			</div>
		</popup>

    </div>
</template>
<script>
import Popup from "@/components/Popup.vue";
import { GetMyShopList, AddShop, AuthShop } from '@/api/open'

export default{
    data(){
        return{
            open_type:1,
            list:[],
            shop_list:[
                {
                    type:1,
                    name:'快手开放平台'
                }
            ],
            is_popup_show:false
        }
    },
    filters:{

    },
    components: {
			Popup
	},
    computed:{

    },
    watch:{


    },
    async mounted(){
        const {code,state} = this.$route.query;
        if(code) {
            this.doAuth(code,state)
        }
        this.onGetList();
    },
    methods:{
        doAuth(code,state) {
			AuthShop({
   				code,
				shop_id:state
			}).then((response) => {
				this.onGetList();
			}).catch(res => {
				this.$layer.msg(res.msg)
			}).finally(() => {
				this.$router.replace({
					name: 'OpenShop',
				});
			})
        },
        addShop() {
           this.is_popup_show = true
        },
        auth(shop_id) {
			let scope = 'merchant_scm,merchant_item,user_info,merchant_video,merchant_material,merchant_servicemarket,merchant_user,merchant_comment,merchant_logistics';
			let redirect_uri = 'https://www.yichuanghub.com/workbench/openShop'
			let url = 'https://open.kwaixiaodian.com/oauth/authorize?app_id=ks715790866643754430&redirect_uri='+redirect_uri+'&scope='+scope+'&response_type=code&state=' + shop_id
           
			window.location = url
        },
        close() {
           this.is_popup_show = false
        },
        submit(){
            let open_name = this.shop_list.find((i)=>{
                return i.type == this.open_type
            }).name

			AddShop({
   				open_type: this.open_type,
                open_name
			}).then((response) => {
				this.onGetList();
			}).catch(res => {
				this.$layer.msg(res.msg)
			}).finally(() => {
				this.is_popup_show = false
			})


        },
        async onGetList() {
            this.list = []
            const {data} = await GetMyShopList();
            this.list = data;
        },
    }
}
</script>
<style lang="scss" scoped>

   .container {
        width: 100%;
        height: 100%;
        padding: 20px 100px 180px 30px;
        .panel {
			margin-bottom: 10px;
			padding: 8px 30px;
			background: white;
			h2 {
				position: relative;
				color: #333333;
				padding: 24px 0;
				border-bottom: 1px solid #EBEBEB;
				font-size: 18px;
				font-weight: bold;
				.btn-add {
					position: absolute;
					top: 20px;
					right: 0;
					width: 110px;
					height: 40px;
					line-height: 40px;
					text-align: center;
					background: #FA3D5A;
					color: white;
					border-radius: 10px;
					font-size: 12px;
					cursor: pointer;
				}
			}

			.table {
				background: #FFFFFF;
				border: 1px solid #E3E3E3;
				margin-top: 20px;
				font-size: 14px;
				color: #191A1C;
				.item,
				.header {
					display: flex;

					div {
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						text-align: center;
					}

					.name {
						width: 120px;
						padding-left: 20px;
					}

					.openid {
						width: 250px;
						padding-left: 20px;
					}

					.auth {
						width: 200px;
						padding-left: 20px;
					}
					.action {
						width: 180px;
						padding-left: 20px;
					}
				}

				.header {
					background: #EDEFF2;
					height: 40px;
					line-height: 40px;
				}

				.item {
					height: 80px;
					line-height: 80px;
					border-bottom: 1px solid #DDDDDD;
					&:last-child {
						border: none;
					}
					.action {
						display: flex;
						justify-content: space-around;
						align-items: center;

						.btn-plain {
							cursor: pointer;
						}

						.btn-default {
							width: 65px;
							height: 25px;
							line-height: 25px;
							border: 1px solid #696A6A;
							border-radius: 13px;
							font-size: 12px;
							cursor: pointer;
							&.btn-default-yes {
								background: rgba(250,61,90, 0.2);
								color: #FA3D5A;
								border: none;
							}
							&.btn-default-no {
								background: white;
								color: #68696A;
							}
						}
					}
				}

			}

		}
		::v-deep .popup-modal {
			h2 {
				padding: 10px 20px;
				color: #333333;
				font-size: 18px;
				font-weight: bold;
				border-bottom: 1px solid #F0F0F0;
			}
			.form {
				padding: 10px 0;
				.form-group {
					display: flex;
					flex-wrap: wrap;
					justify-content: left;
					align-items: center;
					margin-top: 20px;
					.form-label {
						width: 50px;
						font-size: 14px;
						color: #696A6A;
						text-align: right;
					}
					.form-control {
						position: relative;
                        .input,
                        select {
                            width: 100%;
                            height: 43px;
                            line-height: 43px;
                            padding: 0 15px;
                            border: 1px solid #e2e5e9;
                            font-size: 14px;
                        }
					}
				}

				.btn-submit {
					margin: 40px auto;
					width: 80%;
					height: 40px;
					line-height: 40px;
					text-align: center;
					background: #FA3D5A;
					color: white;
					border-radius: 6px;
					cursor: pointer;
				}

			}
		}
	}

	::v-deep .ivu-input {
		width: 300px;
		height: 48px;
		line-height: 48px;
		border: 1px solid #E3E3E3;
		border-radius: 10px;
		padding: 0 10px;
		outline: none;
	}
</style>
